<template lang='pug'>
  r-table(
    no-data-text='Sin facturas.'
    no-remove
    param-search='number'
    ref='table'
    v-bind='tableProps'
    @detail='selected = $event.item.reset(); dialog = true;'
    )
    template( 
      slot='actions' 
      slot-scope='props' 
      )
      r-btn-action( 
        color='dark'
        tooltip='PDF'
        @click='props.item.toPdf();' 
        )
        v-icon picture_as_pdf
    template( slot='items' )
      r-dialog(
        content-class='grey lighten-3'
        no-confirm
        title='Factura de venta'
        v-model='dialog'
        )
        r-form(
          class='white'
          v-bind='formProps'
          v-model='selected'
          )
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
  //
  import SlSaleInvoiceHeaders from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceHeaders'
  import SlSaleInvoiceFields from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFields'
  import SlSaleInvoiceFilters from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFilters'
  import SlSaleInvoiceService from '@/services/api/Sale/SlSaleInvoice'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      formProps() {
        return {
          editable: false,
          fields: SlSaleInvoiceFields,
        }
      },
      tableProps() {
        return {
          filters: SlSaleInvoiceFilters
            .exclude(['number'])
            .prop('sl_customer_branch_offices_id', {
              noAsyncSearch: true, 
              paramFilter: { 
                sl_customer_id: this.$route.params.id 
              },
            }),
          headers: SlSaleInvoiceHeaders.get('customer_detail'),
          service: SlSaleInvoiceService,
          initialFilterValues: {
            recent: '30',
          },
          paramFilter: {
            sl_customer_id: this.$route.params.id,
          },
        }
      },
    },
    data() {
      return {
        dialog: false,
        recent: '',
        selected: null,
      }
    },
  }
</script>
